/* eslint-disable */
import React from "react";
import {
  AuditOutlined,
  UserAddOutlined,
  DashboardOutlined,
  TeamOutlined,
  BarChartOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  ToolOutlined,
  WalletOutlined,
  CreditCardOutlined,
  SafetyCertificateOutlined,
  SearchOutlined,
  UnorderedListOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  PercentageOutlined,
  StopOutlined,
  PlusOutlined,
  OrderedListOutlined,
  AppstoreOutlined,
  CustomerServiceOutlined,
  UnlockOutlined,
  LineChartOutlined,
  MobileOutlined,
} from "@ant-design/icons";

function item(label, key, icon, children) {
  return { key, label, icon, children };
}

/* ─── Operário nav ────────────────────────────── */
export const operarioNavItems = (isSuperUser = false) => [
  item("Dashboard",           "dashboard", <DashboardOutlined />),
  item("Registar Cliente",    "1",    <UserAddOutlined />),
  item("Gestão de Clientes",  "gc",   <TeamOutlined />, [
    item("Pesquisar Cliente",      "gc-1", <SearchOutlined />),
    item("Listar Clientes",        "gc-2", <UnorderedListOutlined />),
    item("Importar Clientes",      "gc-3", <UsergroupAddOutlined />),
    item("Clientes c/ Desconto",   "gc-4", <PercentageOutlined />),
    item("Clientes Isentos",       "gc-5", <StopOutlined />),
  ]),
  item("App Clientes",        "apps-moveis", <MobileOutlined />),
  item("Gestão de Compras",   "24",   <ShoppingCartOutlined />),
  // A par do administrador: o operário emite recargas, e vê a lista inteira
  // com o nome de quem emitiu cada uma.
  item("Recargas Emitidas",   "recargas-emitidas", <AuditOutlined />),
  ...(isSuperUser
    ? [item("Recargas Recargatest", "224", <CreditCardOutlined />)]
    : []),
  item("Gestão de Contadores", "cnt", <ToolOutlined />, [
    item("Registar Contador",    "cnt-1", <PlusOutlined />),
    item("Pesquisar Contador",   "cnt-2", <SearchOutlined />),
    item("Gestão Operacional",   "cnt-3", <OrderedListOutlined />),
  ]),
  item("Relatórios", "reports", <BarChartOutlined />),
];

/* ─── Admin nav ───────────────────────────────── */
export const adminNavItems = () => [
  item("Dashboard",           "dashboard", <DashboardOutlined />),
  item("Gestão de Compras",    "1",   <ShoppingCartOutlined />),
  item("Emitir recarga",       "admin-recarga-test", <CreditCardOutlined />),
  // Logo a seguir a emitir: quem emite deve ver, no menu, que a emissão fica
  // registada e é revista.
  item("Recargas Emitidas",    "admin-recargas-emitidas", <AuditOutlined />),
  item("Gestão de Pagamentos", "21",  <WalletOutlined />),
  item("Gestão de Clientes",  "admin-gc",   <TeamOutlined />, [
    item("Pesquisar Cliente",      "admin-gc-1", <SearchOutlined />),
    item("Listar Clientes",        "admin-gc-2", <UnorderedListOutlined />),
    item("Importar Clientes",      "admin-gc-3", <UsergroupAddOutlined />),
    item("Clientes c/ Desconto",   "admin-gc-4", <PercentageOutlined />),
    item("Clientes Isentos",       "admin-gc-5", <StopOutlined />),
  ]),
  item("Gestão de Contadores", "admin-cnt", <ToolOutlined />, [
    item("Registar Contador",    "admin-cnt-1", <PlusOutlined />),
    item("Pesquisar Contador",   "admin-cnt-2", <SearchOutlined />),
    item("Gestão Operacional",   "admin-cnt-3", <OrderedListOutlined />),
  ]),
  item("Gestão de STS",        "sts", <SafetyCertificateOutlined />),
  item("Taxas e Bairros",      "taxSettings", <PercentageOutlined />),
  item("Marcas de Contador",   "meterBrands", <ToolOutlined />),
  item("Apps Móveis",          "mobileApps", <AppstoreOutlined />),
  item("Utilizadores",         "users", <UserSwitchOutlined />),
  item("Relatórios", "reports", <BarChartOutlined />),
];

/* ─── IRS nav (mesa de atendimento) ─────────────
   "Pesquisar Cliente" aponta para o ecrã do atendimento (IrsClients), não para
   o de gestão da operação — aquele apaga clientes e troca contadores, coisas
   que a mesa de atendimento não faz. */
export const irsNavItems = () => [
  item("Fila de Triagem", "irs-queue", <CustomerServiceOutlined />),
  item("Painel de Atendimento", "dashboard", <DashboardOutlined />),
  item("Pesquisar Cliente", "irs-clientes", <SearchOutlined />),
  item("Gestão de Compras", "irs-compras", <ShoppingCartOutlined />),
  item("Tendências", "irs-tendencias", <LineChartOutlined />),
  item("Desbloquear Contador", "irs-desbloqueio", <UnlockOutlined />),
];

/* ─── Contabilidade nav ───────────────────────── */
export const contabilidadeNavItems = () => [
  item("Dashboard", "dashboard", <DashboardOutlined />),
  item("Relatórios de Venda", "1", <FileTextOutlined />),
];

/* ─── Test/Recharge nav ───────────────────────── */
export const recargatestNavItems = () => [
  item("Dashboard", "dashboard", <DashboardOutlined />),
  item("Recarga test", "1", <CreditCardOutlined />),
];
